import { render } from "./HelloWorld.vue?vue&type=template&id=abe9096a&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=abe9096a&scoped=true&lang=less"

import exportComponent from "/Users/coohua/shiNet/g1-pro/g1-privacy-pro/privacy2H5Source/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe9096a"]])

export default __exports__